import PropTypes from 'prop-types';
import React from 'react';

import BackButton from '@/components/BackButton';
import Breadcrumbs, { Breadcrumb } from '@/components/Breadcrumbs';
import LazyEditForm from '@/components/LazyEditForm';
import Page from '@/components/Page';
import PageContent from '@/components/PageContent';
import PageHeader from '@/components/PageHeader';
import PageTitle from '@/components/PageTitle';
import PaperSheet from '@/components/PaperSheet';
import { ROUTE_PATH as GIFT_SETS_PATH } from '@/features/giftSetsPage/consts';

import Form from './Form';

const PageEditGiftSet = ({
  fetchItem,
  getItemLoadingError,
  isItemLoaded,
  isItemLoading,
  giftSetId,
  updateGiftSet,
}) => (
  <Page>
    <PageHeader gutterBottom={false} xl={8}>
      <Breadcrumbs>
        <Breadcrumb to={GIFT_SETS_PATH}>Подарочный набор</Breadcrumb>
      </Breadcrumbs>
      <BackButton />
      <PageTitle>Редактирование Подарочного набора</PageTitle>
    </PageHeader>
    <PageContent xl={8}>
      <PaperSheet>
        <LazyEditForm
          fetchItem={fetchItem}
          getItemLoadingError={getItemLoadingError}
          isItemLoaded={isItemLoaded}
          isItemLoading={isItemLoading}
          itemId={giftSetId}
        >
          <Form giftSetId={giftSetId} onSubmit={updateGiftSet} />
        </LazyEditForm>
      </PaperSheet>
    </PageContent>
  </Page>
);

PageEditGiftSet.propTypes = {
  fetchItem: PropTypes.func.isRequired,
  getItemLoadingError: PropTypes.func.isRequired,
  isItemLoaded: PropTypes.func.isRequired,
  isItemLoading: PropTypes.func.isRequired,
  updateGiftSet: PropTypes.func.isRequired,
  giftSetId: PropTypes.any.isRequired,
};

export default PageEditGiftSet;
